const ApiResponse = class {
  constructor({ success = true, code = '200', result = null, errorCode = '400', message }) {
    this.success = success
    this.code = code
    this.errorCode = errorCode
    this.result = result
    this.message = message
  }

  get failed() {
    return !this.success
  }

  static ok({ result }) {
    return new ApiResponse({ result })
  }

  static fail({ code, message, result, errorCode }) {
    return new ApiResponse({
      success: false,
      code,
      errorCode,
      message,
      result
    })
  }
}

export const isApiResponseWrapped = (object) => {
  if (!object) return false

  return (
    Object.prototype.hasOwnProperty.call(object, 'success') &&
    Object.prototype.hasOwnProperty.call(object, 'code') &&
    Object.prototype.hasOwnProperty.call(object, 'result') &&
    Object.prototype.hasOwnProperty.call(object, 'message')
  )
}

export default ApiResponse
